// Extract unique filter values from task data
export const extractFilterValues = (data) => {
  const categories = [...new Set(data.map((task) => task.category))].sort()
  const staffMembers = [...new Set(data.map((task) => task.assignedToStaffName))].sort()
  const priorities = ['Critical', 'High', 'Medium', 'Low']
  const statuses = ['Pending', 'Completed']

  return {
    categories,
    staffMembers,
    priorities,
    statuses
  }
}

// Apply filters to task data
export const applyFilters = (data, filters) => {
  const { searchText, statusFilter, priorityFilter, categoryFilter, dateRange } = filters

  return data.filter((task) => {
    // Text search
    const textMatch =
      searchText === '' ||
      task.patientName.toLowerCase().includes(searchText.toLowerCase()) ||
      task.taskDescription.toLowerCase().includes(searchText.toLowerCase()) ||
      task.taskId.toLowerCase().includes(searchText.toLowerCase()) ||
      task.assignedToStaffName.toLowerCase().includes(searchText.toLowerCase())

    // Status filter
    const statusMatch = statusFilter === 'all' || task.taskStatus === statusFilter

    // Priority filter
    const priorityMatch = priorityFilter === 'all' || task.priority === priorityFilter

    // Category filter
    const categoryMatch = categoryFilter === 'all' || task.category === categoryFilter

    // Date range filter
    let dateMatch = true
    if (dateRange && dateRange[0] && dateRange[1]) {
      const dueDate = new Date(task.dueDate)
      const startDate = dateRange[0].startOf('day').toDate()
      const endDate = dateRange[1].endOf('day').toDate()
      dateMatch = dueDate >= startDate && dueDate <= endDate
    }

    return textMatch && statusMatch && priorityMatch && categoryMatch && dateMatch
  })
}

// Split filtered data by status
export const splitByStatus = (filteredData) => {
  const pendingTasks = filteredData.filter((task) => task.taskStatus === 'Pending')
  const completedTasks = filteredData.filter((task) => task.taskStatus === 'Completed')

  return {
    pendingTasks,
    completedTasks
  }
}
